import React from 'react';
import { MessageSquareIcon, MessageCircleIcon, MailIcon, PhoneIcon, BrainIcon, BookOpenIcon, SearchIcon } from 'lucide-react';
const Slide2 = () => {
  return <section className="slide bg-white rounded-lg p-8 md:p-12 overflow-hidden" data-id="element-2517">
      <div className="flex flex-col space-y-6" data-id="element-2518">
        {/* Title */}
        <h2 className="text-3xl font-bold text-center mb-6" data-id="element-2519">
          Meet shoppers where they are
        </h2>
        {/* New Taxonomy Section */}
        <div className="bg-blue-50 rounded-lg p-4 border border-blue-200 mb-4" data-id="element-2520">
          <h3 className="font-semibold text-blue-800 mb-2 flex items-center" data-id="element-2521">
            <BrainIcon className="h-5 w-5 mr-2 text-blue-600" data-id="element-2522" />
            New Taxonomy Hidden Layer
          </h3>
          <p className="text-gray-700 text-sm" data-id="element-2523">
            We're developing a new taxonomy hidden layer that enables natural
            conversations across all channels. This semantic layer understands
            product relationships, attributes, and customer needs to provide
            consistent, intelligent responses.
          </p>
        </div>
        {/* Channels */}
        <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-2524">
          {['Website', 'Messenger', 'Comments', 'WhatsApp', 'Telegram', 'Email'].map(channel => <span key={channel} className="bg-indigo-100 text-indigo-700 px-3 py-1 rounded-full text-sm font-medium" data-id="element-2525">
              {channel}
            </span>)}
        </div>
        {/* Subtitle */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 max-w-3xl mx-auto mb-8" data-id="element-2526">
          <h3 className="font-semibold text-amber-800 mb-2" data-id="element-2527">
            For Sonae MC's Brands:
          </h3>
          <ul className="text-gray-700 space-y-2" data-id="element-2528">
            <li className="flex items-center gap-2" data-id="element-2529">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2530"></div>
              <span data-id="element-2531">Continente — hyper/super markets</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2532">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2533"></div>
              <span data-id="element-2534">Modelo — medium-sized</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2535">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2536"></div>
              <span data-id="element-2537">Bom Dia — convenience</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-2538">
              <div className="w-2 h-2 bg-indigo-600 rounded-full" data-id="element-2539"></div>
              <span data-id="element-2540">Online — e-commerce & delivery</span>
            </li>
          </ul>
        </div>
        {/* Knowledge Base Section */}
        <div className="bg-green-50 rounded-lg p-5 border border-green-200 mb-6" data-id="element-2541">
          <div className="flex items-start gap-4" data-id="element-2542">
            <div className="bg-green-100 rounded-full p-3 flex-shrink-0" data-id="element-2543">
              <BookOpenIcon className="h-6 w-6 text-green-600" data-id="element-2544" />
            </div>
            <div data-id="element-2545">
              <h3 className="text-lg font-semibold text-green-800 mb-2" data-id="element-2546">
                Knowledge Base
              </h3>
              <p className="text-gray-700 mb-3" data-id="element-2547">
                Our comprehensive knowledge base powers all customer
                interactions with:
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-3" data-id="element-2548">
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2549">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2550">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2551"></div>
                    Product Advice
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2552">
                    Personalized recommendations based on customer needs and
                    preferences
                  </p>
                </li>
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2553">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2554">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2555"></div>
                    Product Features
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2556">
                    Detailed specifications and unique selling points for all
                    catalog items
                  </p>
                </li>
                <li className="bg-white rounded-lg p-3 border border-gray-200" data-id="element-2557">
                  <h4 className="font-medium text-green-700 mb-1 flex items-center" data-id="element-2558">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-2" data-id="element-2559"></div>
                    Customer Questions
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-2560">
                    Instant answers to common queries about policies,
                    availability, and more
                  </p>
                </li>
              </ul>
              <p className="text-sm text-gray-700" data-id="element-2561">
                Empowers both online shoppers and offline store representatives
                with consistent, accurate information.
              </p>
            </div>
          </div>
        </div>
        {/* Visualization - Simplified */}
        <div className="mt-4 max-w-4xl mx-auto" data-id="element-2562">
          <div className="grid grid-cols-2 gap-8 py-6" data-id="element-2563">
            <div className="flex justify-end" data-id="element-2564">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2565">
                <div className="flex items-center gap-3 mb-2" data-id="element-2566">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2567">
                    <MessageSquareIcon className="h-5 w-5 text-indigo-600" data-id="element-2568" />
                  </div>
                  <h3 className="font-medium" data-id="element-2569">Website Chat</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2570">
                  Embedded on all product pages and checkout
                </p>
              </div>
            </div>
            <div data-id="element-2571">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2572">
                <div className="flex items-center gap-3 mb-2" data-id="element-2573">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2574">
                    <MessageCircleIcon className="h-5 w-5 text-indigo-600" data-id="element-2575" />
                  </div>
                  <h3 className="font-medium" data-id="element-2576">Social Media</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2577">
                  Messenger, Comments, and DMs
                </p>
              </div>
            </div>
            <div className="flex justify-end" data-id="element-2578">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2579">
                <div className="flex items-center gap-3 mb-2" data-id="element-2580">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2581">
                    <PhoneIcon className="h-5 w-5 text-indigo-600" data-id="element-2582" />
                  </div>
                  <h3 className="font-medium" data-id="element-2583">WhatsApp</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2584">
                  Direct messaging for customers on the go
                </p>
              </div>
            </div>
            <div data-id="element-2585">
              <div className="bg-white rounded-lg p-4 border border-gray-200 w-64" data-id="element-2586">
                <div className="flex items-center gap-3 mb-2" data-id="element-2587">
                  <div className="bg-indigo-100 rounded-full p-2" data-id="element-2588">
                    <MailIcon className="h-5 w-5 text-indigo-600" data-id="element-2589" />
                  </div>
                  <h3 className="font-medium" data-id="element-2590">Email</h3>
                </div>
                <p className="text-sm text-gray-600" data-id="element-2591">
                  Personalized recommendations and follow-ups
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Knowledge Base Search Example */}
        <div className="bg-white rounded-lg border border-gray-200 p-4 max-w-md mx-auto" data-id="element-2592">
          <div className="flex items-center gap-2 mb-3" data-id="element-2593">
            <SearchIcon className="h-5 w-5 text-gray-500" data-id="element-2594" />
            <input type="text" placeholder="Search knowledge base..." className="w-full border border-gray-200 rounded-lg py-2 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" defaultValue="Continente product features" data-id="element-2595" />
          </div>
          <div className="p-3 border border-indigo-200 rounded-lg bg-indigo-50" data-id="element-2596">
            <h4 className="font-medium text-indigo-800 mb-1" data-id="element-2597">
              Smart Knowledge Retrieval
            </h4>
            <p className="text-sm text-gray-700" data-id="element-2598">
              The same knowledge powers all channels, ensuring consistent
              answers whether customers interact via chat, WhatsApp, or with
              in-store staff.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default Slide2;